import { Smartphone, Copy } from "lucide-react";
import { toast } from "sonner";
import { useLoad } from "@/components/common";

export function PayAccounts({ compact }) {
  const { data } = useLoad("/payment-accounts");
  if (!data) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 p-4" data-testid="payment-accounts">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-900"><Smartphone className="h-4 w-4" /> Send your money to the company account</div>
      {!compact && <p className="mt-1 text-xs text-amber-900/80">Use MTN or Airtel mobile money. Put your name or phone number as the reference, then report the payment here so our team can confirm it.</p>}
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {data.map((a) => (
          <div key={a.provider} className="rounded-lg border bg-white p-3" data-testid={`pay-account-${a.provider.split(" ")[0].toLowerCase()}`}>
            <div className="text-xs font-bold uppercase tracking-wider text-stone-500">{a.provider}</div>
            {a.number ? (
              <button type="button" className="mt-1 inline-flex items-center gap-1.5 font-mono text-lg font-bold text-brand" onClick={() => { navigator.clipboard?.writeText(a.number); toast.success("Number copied"); }}>
                {a.number}<Copy className="h-3.5 w-3.5 text-stone-400" />
              </button>
            ) : <div className="mt-1 text-sm text-stone-500">[Number not set yet — admin adds it in Settings]</div>}
            {a.name && <div className="text-xs text-stone-600">Account name: <b>{a.name}</b></div>}
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] text-amber-900/70">Only send money to these official numbers. Staff will never ask you to send money to a personal number.</p>
    </div>
  );
}
